import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as actionTypes from './constants';

import {
  entitySearchSuccess,
  entitySearchFailure,
} from '../entity-filter/containers/entity-filter-actions';

export function* doSearchEntities(action) {
  try {
    const {
      type,
      searchValue,
      filters,
      sort,
      worklistId,
      page = 1,
      pageSize = 5,
      showAll,
      oldSearch = false,
    } = action.payload;
    const endpoint = oldSearch ?
      `search/${type?.toLowerCase()}?pageSize=${pageSize}&page=${page}` :
      // eslint-disable-next-line max-len
      `worklist/${worklistId?.toLowerCase()}/search?entityType=${type?.toLowerCase()}${filters ? `&filters=${filters}` : ''}${sort ? `&sort=${sort}` : ''}&pageSize=${pageSize}&page=${page}`;
    const results = yield call(callApi, {
      endpoint,
      options: {
        method: 'POST',
        body: JSON.stringify({
          query: searchValue,
        }),
        errorMessage: `Could not fetch search results for ${searchValue}`,
        retryAction: action,
      },
    });
    yield put(entitySearchSuccess({ ...results, showAll }));
  } catch (err) {
    yield put(entitySearchFailure(err));
  }
}

function* watchSearchEntities() {
  yield takeLatest(actionTypes.ENTITY_SEARCH_REQUEST, doSearchEntities);
}

function* watchSearchAllEntities() {
  yield takeLatest(actionTypes.ENTITY_SEARCH_ALL_REQUEST, doSearchEntities);
}

export default [
  fork(watchSearchEntities),
  fork(watchSearchAllEntities),
];
